<div class="d-flex flex-column gap-4 p-3 w-100" style="background: var(--neutral-white, #FFF);">
  <!-- ... existing content ... -->
  <div class="d-flex justify-content-between align-items-center pb-3 border-bottom border-2">
    <div class="fs-5 fw-bold">Current Instant Rates</div>
  </div>

  <div class="d-flex flex-row justify-content-between">
    <div class="d-flex gap-2">
      <button type="button" (click)="openCreateRateModal()"
        class="btn btn-secondary text-white d-flex align-items-center">
        <i class="bi bi-plus-circle me-2"></i>Add Rate</button>

      <button type="button" (click)="openBulkCreateRateModal()"
        class="btn btn-outline-secondary d-flex align-items-center">
        <i class="bi bi-file-earmark-arrow-up me-2"></i>Import</button>
    </div>

    <button class="btn btn-light d-flex align-items-center gap-2" type="button" (click)="goTo('/instant-rate-manager')">
      <i class="bi bi-arrow-left"></i>
      Back to Instant Rate Manager
    </button>
  </div>

  <div class="d-flex flex-wrap align-items-center justify-content-between w-100 gap-3">
    <div class="d-flex flex-wrap align-items-center gap-3 flex-grow-1" style="min-width: 250px;">
      <!-- <div #groupContainer class="position-relative flex-grow-1 group-select"
        style="min-width: 100px; max-width: 200px;">
        <ng-select #groupSelector class="w-100 custom-select-icon no-caret" [items]="groupArray"
          (change)="onGroupChange($event)" placeholder="Search by group">
        </ng-select>
        <i
          class="bi bi-search position-absolute top-50 end-0 translate-middle-y me-3 text-muted pointer-events-none"></i>
      </div> -->
      <div class="flex-grow-1" style="min-width: 100px; max-width: 200px;">
        <ng-select class="w-100" [items]="rateCategoryArray" (change)="onRateCategoryChange($event)"
          placeholder="Select rate category"></ng-select>
      </div>
    </div>
    <div class="d-flex flex-wrap align-items-center gap-2 flex-shrink-0">

      <button class="btn btn-outline-secondary d-flex align-items-center" type="button" (click)="downloadCsvRate()"
        [disabled]="totalRates === 0">
        <i class="bi bi-download me-2"></i>
        Export as CSV
      </button>
    </div>
  </div>

  <div class="d-flex flex-row justify-content-end align-items-center w-100 gap-3">
    <app-saved-search #savedSearch [gridApi]="gridApi" [viewFilterType]="viewFilterType" [module]="module" (onClearFilters)="clearFiltersExternally()"></app-saved-search>
  </div>

  <ag-grid-angular class="ag-theme-alpine w-100" style="height: 600px;" [columnDefs]="columnDefs"
    [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
    [appSavedSearchSync]="savedSearch"
    (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</div>
